// Message constants
export var COPY_PERSONAL_DETAILS_UPDATE_FAILURE = "Sorry, there was an issue updating your details. Please try again.";
export var COPY_PERSONAL_DETAILS_UPDATE_SUCCESS = "Your details have been updated.";
export var COPY_GENERIC_ERROR = "Something went wrong. Please try again later."; // Links

export var LOGIN_URL = "/login";